/**
 * Lista de empresas con su botón «Permisos» (spec 2026-10-07 §4). Solo
 * presenta: las filas y su estado salen de lib/user_company_list.
 */
import React from 'react';
import { Button, List, Tooltip } from 'antd';

export const CompanyPermissionsList = ({ rows, onOpen }) => (
  <List
    size="small"
    bordered
    locale={{ emptyText: 'No hay empresas vinculadas.' }}
    dataSource={rows}
    renderItem={row => (
      <List.Item
        key={row.cid}
        actions={[
          <Tooltip key="perm" title={row.hint || ''}>
            <span>
              <Button type="link" disabled={!row.canOpen} onClick={() => onOpen(row)}>Permisos</Button>
            </span>
          </Tooltip>,
        ]}
      >
        {row.name}
      </List.Item>
    )}
  />
);

export default CompanyPermissionsList;
